import React from 'react';
import { IconSvgProps, SvgProps } from './types';
import { Svg as SvgEmotion } from './styles';
import { Preloader } from '../Preloader';

import {
  IconAccept,
  IconAcceptM,
  IconAgreement,
  IconApple,
  IconArrowDown,
  IconArrowDownThin,
  IconArrowLeft,
  IconArrowRight,
  IconBankCard,
  IconCalendar,
  IconCapture,
  IconCheck,
  IconClose,
  IconCloseM,
  IconCopy,
  IconDecline,
  IconDeclineM,
  IconDropdown,
  IconEdit,
  IconExcel,
  IconExchange,
  IconExclamationMark,
  IconEyeClosed,
  IconEyeOpen,
  IconFilter,
  IconHistory,
  IconInfo,
  IconInfoM,
  IconInfoSign,
  IconKyc,
  IconLanguageEn,
  IconLanguageEs,
  IconLanguageRu,
  IconLegendGraphColumn,
  IconLegendGraphWave,
  IconLocker,
  IconLogin,
  IconLogout,
  IconMastercard,
  IconMenu,
  IconMinus,
  IconMinusThin,
  IconOrderAlert,
  IconOrderOk,
  IconPassport,
  IconPlus,
  IconPlusThin,
  IconProfile,
  IconQuestion,
  IconQuestionSign,
  IconQuestionStroke,
  IconSearch,
  IconSecurity,
  IconShare,
  IconSorting,
  IconStatusPartFilled,
  IconStatusPlaced,
  IconStatusRejected,
  IconSupport,
  IconTelegram,
  IconTrash,
  IconTwitter,
  IconUT,
  IconUtmedia,
  IconVisa,
  IconWallets,
  IconWarning,
  IconWireTransfer,
  IconYoutube,
  IconGear,
  IconGooglePlay,
  IconMasterCardMini,
  IconApplePay,
  IconGooglePay,
  IconBank,
  IconCard,
  IconMainAcc,
  IconUtt,
  IconUtex,
  IconPayeer
} from './icons';

export const Svg = (props: SvgProps) => (
  <SvgEmotion
    width={24 as any}
    height={24 as any}
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  />
);

export const IconSvg = (props: IconSvgProps & SvgProps) => {
  const { src, ...restProps } = props;

  switch (src) {
    case 'check':
      return <IconCheck {...restProps} />;

    case 'preloader':
      return <Preloader size={restProps.width} color={restProps.color} />;

    case 'question':
      return <IconQuestion {...restProps} />;

    case 'question-stroke':
      return <IconQuestionStroke {...restProps} />;

    case 'arrowLeft':
      return <IconArrowLeft {...restProps} />;

    case 'close':
      return <IconClose {...restProps} />;

    case 'close-m':
      return <IconCloseM {...restProps} />;

    case 'copy':
      return <IconCopy {...restProps} />;

    case 'dropdown':
      return <IconDropdown {...restProps} />;

    case 'eye-open':
      return <IconEyeOpen {...restProps} />;

    case 'eye-closed':
      return <IconEyeClosed {...restProps} />;

    case 'calendar':
      return <IconCalendar {...restProps} />;

    case 'excel':
      return <IconExcel {...restProps} />;

    case 'edit':
      return <IconEdit {...restProps} />;

    case 'menu':
      return <IconMenu {...restProps} />;

    case 'sorting':
      return <IconSorting {...restProps} />;

    case 'agreement':
      return <IconAgreement {...restProps} />;

    case 'plus':
      return <IconPlus {...restProps} />;

    case 'minus':
      return <IconMinus {...restProps} />;

    case 'plus-thin':
      return <IconPlusThin {...restProps} />;

    case 'minus-thin':
      return <IconMinusThin {...restProps} />;

    case 'decline':
      return <IconDecline {...restProps} />;

    case 'accept':
      return <IconAccept {...restProps} />;

    case 'info':
      return <IconInfo {...restProps} />;

    case 'decline-m':
      return <IconDeclineM {...restProps} />;

    case 'accept-m':
      return <IconAcceptM {...restProps} />;

    case 'exchange':
      return <IconExchange {...restProps} />;

    case 'history':
      return <IconHistory {...restProps} />;

    case 'security':
      return <IconSecurity {...restProps} />;

    case 'passport':
      return <IconPassport {...restProps} />;

    case 'support':
      return <IconSupport {...restProps} />;

    case 'wallets':
      return <IconWallets {...restProps} />;

    case 'logout':
      return <IconLogout {...restProps} />;

    case 'login':
      return <IconLogin {...restProps} />;

    case 'locker':
      return <IconLocker {...restProps} />;

    case 'capture':
      return <IconCapture {...restProps} />;

    case 'search':
      return <IconSearch {...restProps} />;

    case 'arrow-down':
      return <IconArrowDown {...restProps} />;

    case 'arrow-down-thin':
      return <IconArrowDownThin {...restProps} />;

    case 'info-m':
      return <IconInfoM {...restProps} />;

    case 'info-sign':
      return <IconInfoSign {...restProps} />;

    case 'question-sign':
      return <IconQuestionSign {...restProps} />;

    case 'bank-card':
      return <IconBankCard {...restProps} />;

    case 'wire-transfer':
      return <IconWireTransfer {...restProps} />;

    case 'UT':
      return <IconUT {...restProps} />;

    case 'profile':
      return <IconProfile {...restProps} />;

    case 'kyc':
      return <IconKyc {...restProps} />;

    case 'filter':
      return <IconFilter {...restProps} />;

    case 'share':
      return <IconShare {...restProps} />;

    case 'status-placed':
      return <IconStatusPlaced {...restProps} />;

    case 'status-rejected':
      return <IconStatusRejected {...restProps} />;

    case 'status-part-filled':
      return <IconStatusPartFilled {...restProps} />;

    case 'arrow-right':
      return <IconArrowRight {...restProps} />;

    case 'legend-graph-column':
      return <IconLegendGraphColumn {...restProps} />;

    case 'legend-graph-wave':
      return <IconLegendGraphWave {...restProps} />;

    case 'trash':
      return <IconTrash {...restProps} />;

    case 'exclamationMark':
      return <IconExclamationMark {...restProps} />;

    case 'visa':
      return <IconVisa {...restProps} />;

    case 'mastercard':
      return <IconMastercard {...restProps} />;

    case 'order-ok':
      return <IconOrderOk {...restProps} />;

    case 'order-alert':
      return <IconOrderAlert {...restProps} />;

    case 'warning':
      return <IconWarning {...restProps} />;

    case 'gear':
      return <IconGear {...restProps} />;

    case 'apple':
      return <IconApple {...restProps} />;

    case 'telegram':
      return <IconTelegram {...restProps} />;

    case 'youtube':
      return <IconYoutube {...restProps} />;

    case 'utmedia':
      return <IconUtmedia {...restProps} />;

    case 'twitter':
      return <IconTwitter {...restProps} />;

    case 'language-es':
      return <IconLanguageEs {...restProps} />;

    case 'language-en':
      return <IconLanguageEn {...restProps} />;

    case 'language-ru':
      return <IconLanguageRu {...restProps} />;

    case 'google-play':
      return <IconGooglePlay {...restProps} />;

    case 'mastercard-mini':
      return <IconMasterCardMini {...restProps} />;

    case 'apple-pay':
      return <IconApplePay {...restProps} />;

    case 'google-pay':
      return <IconGooglePay {...restProps} />;

    case 'bank':
      return <IconBank {...restProps} />;

    case 'card':
      return <IconCard {...restProps} />;

    case 'payeer':
      return <IconPayeer {...restProps} />;

    case 'utex':
      return <IconUtex {...restProps} />;

    case 'utt':
      return <IconUtt {...restProps} />;

    case 'main-acc':
      return <IconMainAcc {...restProps} />;

    default:
      return null;
  }
};
